// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectMediaProductAdd {
  cursor: pointer;
  width: 100%;
  border: 3px dashed #ced4da;
  border-radius: 15px;
  background-color: rgb(248 248 248);
  padding-left: 45%;
  padding-top: 30px;
}

.selectinputfileProductAdd {
  opacity: 0;
  width: 100%;
  cursor: pointer;
}


.selectBox {
  position: relative;
}

.selectBox select {
  width: 100%;
}

.overSelect {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.checkboxes {
  display: none;
  border: 1px #dadada solid;
  padding: 10px;
  border-radius: 10px;
}

.checkboxes label {
  display: block;
}

.checkboxes label:hover {
  background-color: rgb(0, 123, 255);
  color: white;
}

.dropDownVisible {
  display: block;
}

.dropDownNotVisible {
  display: none;
}

.checkboxes .addButton {
  color: #ffffff;
  background-color: var(--admin-color);
  border-color: var(--admin-color);
  padding: 10px;
  width: 70px;
  border-radius: 10px;
}

.checkboxes .cancelButton {

  background: #f3f3f3;
  border-color: #f3f3f3;
  color: #8a909d;
  padding: 10px;
  width: 70px;
  border-radius: 10px;
}

.checkboxes ul li {
  display: block;
  margin: 3px;
}

.dropDown ul li:hover {
  background-color: #e1e1e1;
}

.listWrapper {
  height: 200px;
  overflow: auto;
}

.listWrapperHeightNone {
  /* height: 150px; */
  overflow: auto;
}

.searchWrapper {
  width: 100%;
  position: relative;
  margin-right: auto;
  padding-left: 0;
  border-radius: 15px;
}

.searchWrapper .input-group {
  margin: 2px 0;
  background-color: #f7f7f7;
  border-radius: 5px;
}

.searchInput {
  color: #8a909d;
  background: transparent;
  padding: 0.5rem 15px;
  border: none;
}

.searchInput:focus {
  background: transparent;
}

.addedOrderTable {
  margin-top: 24px;
}

.noCategorieList,
.noCustomerList {
  opacity: 0;
  visibility: hidden;
  height: 0;
  transition: all 0.5s ease;
}

.categorieList,
.customerList {
  opacity: 1;
  visibility: visible;
  transition: all 1s ease;
  border: 1px solid #ced4da;
  border-radius: 5px;
}

.noCategorieList,
.noProductList {
  opacity: 0;
  visibility: hidden;
  height: 0;
  transition: all 0.5s ease;
}

.productList,
.customerList {
  opacity: 1;
  visibility: visible;
  transition: all 1s ease;
  border: 1px solid #ced4da;
  border-radius: 5px;
}

.selectedCustomer {
  border: none;
}

.categorieList ul#search-results,
.customerList ul#search-results {
  padding-top: 10px;
}

.customerList ul#search-results {
  height: 150px;
  overflow: auto;
}

.categorieList ul#search-results li,
.customerList ul#search-results li {
  padding: 5px 15px;
  cursor: pointer;
  border-bottom: 1px solid #f3f3f3;
}

.categorieList ul#search-results li:last-child,
.customerList ul#search-results li:last-child {
  border-bottom: none;
}

#search-results li input {
  cursor: pointer;
}

#search-results li label {
  margin: 8px 8px 8px 8px;
  cursor: pointer;
}

.closeIcon {
  cursor: pointer;
}

.categorieListbutton {
  padding: 10px 15px 10px 15px;
}

.btn.btn-primary.cancelBtn {
  width: 15%;
  margin-right: 20px;
  background: #f3f3f3;
  border-color: #f3f3f3;
  color: #8a909d;
}

.addBtn {
  width: 15%;
}

.removeProduct {
  cursor: pointer;
}

.countWrapper {
  position: relative;
}

.minusCount,
.plusCount {
  position: absolute;
  cursor: pointer;
}

.minusCount span,
.plusCount span {
  position: relative;
  top: 9px;
}


.minusCount {
  left: -20px;
  width: 33px;
  height: 40px;
  vertical-align: middle;
  text-align: center;
  margin: auto;
  border: 1px solid #eeeeee;
  border-radius: 3px;
  background-color: #eeeeee;
}

.plusCount {
  /* right: 140x; */
  width: 33px;
  height: 40px;
  vertical-align: middle;
  text-align: center;
  margin: auto;
  border: 1px solid #eeeeee;
  border-radius: 3px;
  background-color: #eeeeee;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.quantityInput {
  text-align: center;
  background-color: transparent;
  border: 1px solid #f3f3f3;
  width: 55%;
  height: 40px;
}

.createOrderPage .hasSelected {
  background-color: #f3f3f3;
}

.createOrderPage .hasNotId {
  pointer-events: none;
}

.addedItem {
  margin-left: 21px;
}

.productSearchWrapper #search-results {
  height: 150px;
  overflow: auto;
}

.addressList p {
  font-size: 14px;
  text-transform: capitalize;
}

.searchWrapper #search-btn.btn {
  color: black;
  font-size: 18px;
}

.createOrderPage .checkBoxLabel {
  position: relative;
}

.createOrderPage #search-results input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;

}

.createOrderPage #search-results label:before {
  content: '';
  -webkit-appearance: none;
  border: 1px solid rgb(138, 144, 157);
  background-color: transparent;
  border-radius: 3px;
  padding: 7px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 12px;
}

.createOrderPage #search-results input:checked+label:after {
  content: '';
  display: block;
  position: absolute;
  top: 6px;
  left: 6px;
  width: 5px;
  height: 8px;
  border: solid blue;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.createOrderPage .isShippingAddress label {
  margin-bottom: 0;
  margin-left: 10px;
}

.createOrderPage .isShippingAddress input {
  vertical-align: middle;
}

.createOrderPage .billingAddress {
  cursor: pointer;
}

.createOrderPage .addressModal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  overflow: hidden;
  outline: 0;
}

.createOrderPage .addressModalContent {
  width: 700px;
  max-height: 95%;
  overflow: scroll;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 99;
  transform: translate(-50%, -50%) !important;
  margin: 0 auto;
  background-color: white;
  padding: 30px;
  border-radius: var(--border-radius);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
}

.createOrderPage .closeModal {
  cursor: pointer;
}

.errorMessage {
  /* margin-bottom: 12px; */
}

.searchList {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 8px 14px;
  margin: 8px 0;
  font-size: 13px;
  transition: all 0.2s ease;
}

.searchList:hover {
  background: #f1f3f5;
}

.searchList .categoryName {
  font-weight: 500;
  color: #212529;
}

.searchList .primaryCategoryWrapper {
  display: flex;
  align-items: center;
}

.searchList .primaryCategoryLabel {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 0;
  margin-right: 16px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-size: 13px;
  line-height: 1;
  color: #6c757d;
}

.searchList .primaryCategoryLabel.isPrimary {
  color: #212529;
  font-weight: 600;
}

.searchList .primaryCategoryCheckbox {
  margin: 0 !important;
  width: 16px !important;
  height: 16px !important;
  cursor: pointer;
  accent-color: var(--admin-color, #4c84ff);
  flex-shrink: 0;
  vertical-align: middle;
}

.searchList .removeProduct {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  color: #8a909d;
  transition: all 0.2s ease;
}

.searchList .removeProduct:hover {
  background: #fee2e2;
  color: #dc3545;
}

.searchList .removeProduct .mdi {
  font-size: 16px;
  line-height: 1;
}


.categoryDropDown{
  display: flex;
  align-items: center;
}

.categoryDropDown span{
  margin-left: 10px;
}

/* .ql-container{
  height: 200px !important;
} */

`, "",{"version":3,"sources":["webpack://./src/Components/Product/AddProduct/AddProduct.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,kCAAkC;EAClC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,gCAAgC;EAChC,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;AACV;;;AAGA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;;AAEjB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,oCAAoC;EACpC,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,2CAA2C;EAC3C,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,yCAAyC;EACzC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;GAEG","sourcesContent":[".selectMediaProductAdd {\n  cursor: pointer;\n  width: 100%;\n  border: 3px dashed #ced4da;\n  border-radius: 15px;\n  background-color: rgb(248 248 248);\n  padding-left: 45%;\n  padding-top: 30px;\n}\n\n.selectinputfileProductAdd {\n  opacity: 0;\n  width: 100%;\n  cursor: pointer;\n}\n\n\n.selectBox {\n  position: relative;\n}\n\n.selectBox select {\n  width: 100%;\n}\n\n.overSelect {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n}\n\n.checkboxes {\n  display: none;\n  border: 1px #dadada solid;\n  padding: 10px;\n  border-radius: 10px;\n}\n\n.checkboxes label {\n  display: block;\n}\n\n.checkboxes label:hover {\n  background-color: rgb(0, 123, 255);\n  color: white;\n}\n\n.dropDownVisible {\n  display: block;\n}\n\n.dropDownNotVisible {\n  display: none;\n}\n\n.checkboxes .addButton {\n  color: #ffffff;\n  background-color: var(--admin-color);\n  border-color: var(--admin-color);\n  padding: 10px;\n  width: 70px;\n  border-radius: 10px;\n}\n\n.checkboxes .cancelButton {\n\n  background: #f3f3f3;\n  border-color: #f3f3f3;\n  color: #8a909d;\n  padding: 10px;\n  width: 70px;\n  border-radius: 10px;\n}\n\n.checkboxes ul li {\n  display: block;\n  margin: 3px;\n}\n\n.dropDown ul li:hover {\n  background-color: #e1e1e1;\n}\n\n.listWrapper {\n  height: 200px;\n  overflow: auto;\n}\n\n.listWrapperHeightNone {\n  /* height: 150px; */\n  overflow: auto;\n}\n\n.searchWrapper {\n  width: 100%;\n  position: relative;\n  margin-right: auto;\n  padding-left: 0;\n  border-radius: 15px;\n}\n\n.searchWrapper .input-group {\n  margin: 2px 0;\n  background-color: #f7f7f7;\n  border-radius: 5px;\n}\n\n.searchInput {\n  color: #8a909d;\n  background: transparent;\n  padding: 0.5rem 15px;\n  border: none;\n}\n\n.searchInput:focus {\n  background: transparent;\n}\n\n.addedOrderTable {\n  margin-top: 24px;\n}\n\n.noCategorieList,\n.noCustomerList {\n  opacity: 0;\n  visibility: hidden;\n  height: 0;\n  transition: all 0.5s ease;\n}\n\n.categorieList,\n.customerList {\n  opacity: 1;\n  visibility: visible;\n  transition: all 1s ease;\n  border: 1px solid #ced4da;\n  border-radius: 5px;\n}\n\n.noCategorieList,\n.noProductList {\n  opacity: 0;\n  visibility: hidden;\n  height: 0;\n  transition: all 0.5s ease;\n}\n\n.productList,\n.customerList {\n  opacity: 1;\n  visibility: visible;\n  transition: all 1s ease;\n  border: 1px solid #ced4da;\n  border-radius: 5px;\n}\n\n.selectedCustomer {\n  border: none;\n}\n\n.categorieList ul#search-results,\n.customerList ul#search-results {\n  padding-top: 10px;\n}\n\n.customerList ul#search-results {\n  height: 150px;\n  overflow: auto;\n}\n\n.categorieList ul#search-results li,\n.customerList ul#search-results li {\n  padding: 5px 15px;\n  cursor: pointer;\n  border-bottom: 1px solid #f3f3f3;\n}\n\n.categorieList ul#search-results li:last-child,\n.customerList ul#search-results li:last-child {\n  border-bottom: none;\n}\n\n#search-results li input {\n  cursor: pointer;\n}\n\n#search-results li label {\n  margin: 8px 8px 8px 8px;\n  cursor: pointer;\n}\n\n.closeIcon {\n  cursor: pointer;\n}\n\n.categorieListbutton {\n  padding: 10px 15px 10px 15px;\n}\n\n.btn.btn-primary.cancelBtn {\n  width: 15%;\n  margin-right: 20px;\n  background: #f3f3f3;\n  border-color: #f3f3f3;\n  color: #8a909d;\n}\n\n.addBtn {\n  width: 15%;\n}\n\n.removeProduct {\n  cursor: pointer;\n}\n\n.countWrapper {\n  position: relative;\n}\n\n.minusCount,\n.plusCount {\n  position: absolute;\n  cursor: pointer;\n}\n\n.minusCount span,\n.plusCount span {\n  position: relative;\n  top: 9px;\n}\n\n\n.minusCount {\n  left: -20px;\n  width: 33px;\n  height: 40px;\n  vertical-align: middle;\n  text-align: center;\n  margin: auto;\n  border: 1px solid #eeeeee;\n  border-radius: 3px;\n  background-color: #eeeeee;\n}\n\n.plusCount {\n  /* right: 140x; */\n  width: 33px;\n  height: 40px;\n  vertical-align: middle;\n  text-align: center;\n  margin: auto;\n  border: 1px solid #eeeeee;\n  border-radius: 3px;\n  background-color: #eeeeee;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.quantityInput {\n  text-align: center;\n  background-color: transparent;\n  border: 1px solid #f3f3f3;\n  width: 55%;\n  height: 40px;\n}\n\n.createOrderPage .hasSelected {\n  background-color: #f3f3f3;\n}\n\n.createOrderPage .hasNotId {\n  pointer-events: none;\n}\n\n.addedItem {\n  margin-left: 21px;\n}\n\n.productSearchWrapper #search-results {\n  height: 150px;\n  overflow: auto;\n}\n\n.addressList p {\n  font-size: 14px;\n  text-transform: capitalize;\n}\n\n.searchWrapper #search-btn.btn {\n  color: black;\n  font-size: 18px;\n}\n\n.createOrderPage .checkBoxLabel {\n  position: relative;\n}\n\n.createOrderPage #search-results input[type=\"checkbox\"] {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n\n}\n\n.createOrderPage #search-results label:before {\n  content: '';\n  -webkit-appearance: none;\n  border: 1px solid rgb(138, 144, 157);\n  background-color: transparent;\n  border-radius: 3px;\n  padding: 7px;\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n  cursor: pointer;\n  margin-right: 12px;\n}\n\n.createOrderPage #search-results input:checked+label:after {\n  content: '';\n  display: block;\n  position: absolute;\n  top: 6px;\n  left: 6px;\n  width: 5px;\n  height: 8px;\n  border: solid blue;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.createOrderPage .isShippingAddress label {\n  margin-bottom: 0;\n  margin-left: 10px;\n}\n\n.createOrderPage .isShippingAddress input {\n  vertical-align: middle;\n}\n\n.createOrderPage .billingAddress {\n  cursor: pointer;\n}\n\n.createOrderPage .addressModal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  overflow: hidden;\n  outline: 0;\n}\n\n.createOrderPage .addressModalContent {\n  width: 700px;\n  max-height: 95%;\n  overflow: scroll;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 99;\n  transform: translate(-50%, -50%) !important;\n  margin: 0 auto;\n  background-color: white;\n  padding: 30px;\n  border-radius: var(--border-radius);\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);\n}\n\n.createOrderPage .closeModal {\n  cursor: pointer;\n}\n\n.errorMessage {\n  /* margin-bottom: 12px; */\n}\n\n.searchList {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 6px;\n  padding: 8px 14px;\n  margin: 8px 0;\n  font-size: 13px;\n  transition: all 0.2s ease;\n}\n\n.searchList:hover {\n  background: #f1f3f5;\n}\n\n.searchList .categoryName {\n  font-weight: 500;\n  color: #212529;\n}\n\n.searchList .primaryCategoryWrapper {\n  display: flex;\n  align-items: center;\n}\n\n.searchList .primaryCategoryLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 0;\n  margin-right: 16px;\n  cursor: pointer;\n  user-select: none;\n  font-size: 13px;\n  line-height: 1;\n  color: #6c757d;\n}\n\n.searchList .primaryCategoryLabel.isPrimary {\n  color: #212529;\n  font-weight: 600;\n}\n\n.searchList .primaryCategoryCheckbox {\n  margin: 0 !important;\n  width: 16px !important;\n  height: 16px !important;\n  cursor: pointer;\n  accent-color: var(--admin-color, #4c84ff);\n  flex-shrink: 0;\n  vertical-align: middle;\n}\n\n.searchList .removeProduct {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  color: #8a909d;\n  transition: all 0.2s ease;\n}\n\n.searchList .removeProduct:hover {\n  background: #fee2e2;\n  color: #dc3545;\n}\n\n.searchList .removeProduct .mdi {\n  font-size: 16px;\n  line-height: 1;\n}\n\n\n.categoryDropDown{\n  display: flex;\n  align-items: center;\n}\n\n.categoryDropDown span{\n  margin-left: 10px;\n}\n\n/* .ql-container{\n  height: 200px !important;\n} */\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
